import React, { useState, useMemo, useCallback, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// ==================== CONSTANTS ====================
const SERVICE_TYPES = {
  WEDDING: 'wedding',
  CORPORATE: 'corporate',
  ALL: 'all'
};

const FILTER_BUTTONS = [
  { type: SERVICE_TYPES.WEDDING, label: 'Weddings', icon: '💒', gradient: 'from-rose-500 to-pink-600' },
  { type: SERVICE_TYPES.CORPORATE, label: 'Corporate Events', icon: '🏢', gradient: 'from-amber-500 to-orange-600' }
];

// ==================== DATA ====================
const SERVICES_DATA = [
  {
    id: "bvlgari",
    title: "Bvlgari",
    video: "https://res.cloudinary.com/dx5y2bzdq/video/upload/v1740762992/bvlgari_qgfej2.mp4",
    thumbnailImage: "https://res.cloudinary.com/dx5y2bzdq/image/upload/f_auto,q_auto,w_800/v1740348769/DSC08033_rmj5wk.jpg",
    type: "wedding",
    category: "bvlgari",
    description: "Opulent materials and precision craftsmanship create a sensory experience of uncompromising luxury."
  },
  {
    id: "ihg-event-arabie-saoudite",
    title: "IHG Event - Arabie Saoudite",
    thumbnailImage: "https://res.cloudinary.com/dx5y2bzdq/image/upload/f_auto,q_auto,w_800/v1740354115/a_yrejrq.jpg",
    type: "corporate",
    category: "ihg-event",
    description: "Modern Arabian grandeur infused with sophisticated hospitality for truly memorable corporate gatherings."
  },
  {
    id: "ihg-event-doha",
    title: "IHG Event - Doha",
    thumbnailImage: "https://res.cloudinary.com/dx5y2bzdq/image/upload/f_auto,q_auto,w_800/v1740353855/11-9_fdjlp1.jpg",
    video: "https://res.cloudinary.com/dx5y2bzdq/video/upload/v1740757317/IHG_Event-Retif_mrzzj8.mp4",
    type: "corporate",
    category: "ihg-event",
    description: "Qatari-inspired elegance with innovative design elements elevating the corporate experience."
  },
  {
    id: "les-jardins-romains",
    title: "Les Jardins Romains",
    thumbnailImage: "https://res.cloudinary.com/dx5y2bzdq/image/upload/f_auto,q_auto,w_800/v1740155051/1-9_t4rwpc.jpg",
    video: "https://res.cloudinary.com/dx5y2bzdq/video/upload/v1740692225/JARDIN_D_EDEN_omnefq.mp4",
    type: "wedding",
    category: "mosaique",
    description: "Classical Roman aesthetics reimagined with contemporary sensibilities for a timeless celebration."
  },
  {
    id: "valley-flower",
    title: "Valley Flower",
    thumbnailImage: "https://res.cloudinary.com/dx5y2bzdq/image/upload/f_auto,q_auto,w_800/v1740352399/--11_oll416.jpg",
    video: "https://res.cloudinary.com/dx5y2bzdq/video/upload/v1740763886/1reel_meddeb_2k_lgbbhg.mp4",
    type: "wedding",
    category: "valleyflower",
    description: "Sweeping floral landscapes creating a captivating valley of blooms for your extraordinary day."
  },
  {
    id: "shade",
    title: "Shade",
    thumbnailImage: "https://res.cloudinary.com/dx5y2bzdq/image/upload/f_auto,q_auto,w_800/v1740351496/526A1032_afr90p.jpg",
    type: "wedding",
    category: "shade",
    description: "Sophisticated interplay of light and shadow creating dramatic ambiance and unforgettable moments."
  },
  {
    id: "eden-garden",
    title: "Eden Garden",
    thumbnailImage: "https://res.cloudinary.com/dx5y2bzdq/image/upload/f_auto,q_auto,w_800/v1740483922/-112__dnpw4p.jpg",
    video: "https://res.cloudinary.com/dx5y2bzdq/video/upload/v1740764169/videeooo_ez8gb1.mp4",
    type: "wedding",
    category: "eden",
    description: "Sophisticated interplay of light and shadow creating dramatic ambiance and unforgettable moments."
  },
  {
    id: "sol-luna",
    title: "Sol & Luna",
    thumbnailImage: "https://res.cloudinary.com/dx5y2bzdq/image/upload/f_auto,q_auto,w_800/v1741565144/sol3_ya8lat.jpg",
    type: "wedding",
    category: "sol-luna",
    description: "Sophisticated interplay of light and shadow creating dramatic ambiance and unforgettable moments."
  },
  {
    id: "grassland",
    title: "GrassLand",
    thumbnailImage: "https://res.cloudinary.com/dx5y2bzdq/image/upload/f_auto,q_auto,w_800/v1741611440/pic5_inxg94.jpg",
    video: "https://res.cloudinary.com/dx5y2bzdq/video/upload/v1741611305/decor_2_xezkyj.mp4",
    type: "wedding",
    category: "grassland",
    description: "Sophisticated interplay of light and shadow creating dramatic ambiance and unforgettable moments."
  },
  {
    id: "porsche-event",
    title: "Porshe Event",
    thumbnailImage: "https://res.cloudinary.com/dx5y2bzdq/image/upload/f_auto,q_auto,w_800/v1740435837/34-sur-355_zmstii.jpg",
    type: "corporate",
    category: "porsche-event",
    description: "Precision engineering meets exceptional design in our automotive-inspired corporate experiences."
  },
  {
    id: "jullanar",
    title: "Jullanar",
    thumbnailImage: "https://res.cloudinary.com/dx5y2bzdq/image/upload/f_auto,q_auto,w_800/v1741736136/j_f1m8ow.jpg",
    video: "https://res.cloudinary.com/dx5y2bzdq/video/upload/v1740762495/Morroco_zwhm2u.mp4",
    type: "corporate",
    category: "jullanar",
    description: "Precision engineering meets exceptional design in our automotive-inspired corporate experiences."
  },
  {
    id: "golden-minaret",
    title: "Golden Minaret",
    thumbnailImage: "https://res.cloudinary.com/dx5y2bzdq/image/upload/f_auto,q_auto,w_800/v1740490590/IMG-20250225-WA0012_xlf08o.jpg",
    video: "https://res.cloudinary.com/dx5y2bzdq/video/upload/v1740762495/Morroco_zwhm2u.mp4",
    type: "wedding",
    category: "golden-minaret",
    description: "A timeless celebration of tradition and grandeur, where heritage and romance shine in perfect harmony."
  },
  {
    id: "singapore",
    title: "Singapour",
    video: "https://res.cloudinary.com/dx5y2bzdq/video/upload/v1740692085/singapore_1_rdvr8u.mp4",
    thumbnailImage: "https://res.cloudinary.com/dx5y2bzdq/image/upload/f_auto,q_auto,w_800/v1740226071/DSC03534_tqnwqw.jpg",
    type: "wedding",
    category: "ceremony",
    description: "Urban elegance meets timeless luxury in our iconic Singapore-inspired celebration settings."
  },
  {
    id: "luxury-jungle",
    title: "Luxury Jungle",
    thumbnailImage: "https://res.cloudinary.com/dx5y2bzdq/image/upload/f_auto,q_auto,w_800/v1740350711/6U2A6506_vjbtve.jpg",
    type: "wedding",
    category: "jungle",
    description: "Bold tropical elegance merges with refined sophistication in our captivating jungle-inspired designs."
  },
  {
    id: "camellia-flower",
    title: "Camellia Flower",
    video: "https://res.cloudinary.com/dx5y2bzdq/video/upload/v1740578059/decoration_tamer_hosni_fgwofx.mp4",
    thumbnailImage: "https://res.cloudinary.com/dx5y2bzdq/image/upload/f_auto,q_auto,w_800/v1740239854/096A5586_wurt3g.jpg",
    type: "wedding",
    category: "full-service",
    description: "Delicate blooms arranged with exquisite artistry to create an atmosphere of subtle, refined romance."
  },
  {
    id: "reflection",
    title: "Reflection",
    thumbnailImage: "https://res.cloudinary.com/dx5y2bzdq/image/upload/f_auto,q_auto,w_800/v1740350918/DSC01682_kw1vf7.jpg",
    video: "https://res.cloudinary.com/dx5y2bzdq/video/upload/v1740763125/burjelarab_f10smw.mp4",
    type: "wedding",
    category: "reflection",
    description: "Mirrored elements create an illusion of endless elegance, amplifying the magic of your celebration."
  },
  {
    id: "blue-dream",
    title: "Blue Dream",
    thumbnailImage: "https://res.cloudinary.com/dx5y2bzdq/image/upload/f_auto,q_auto,w_800/v1741739534/096A3961_mtxcmx.jpg",
    type: "wedding",
    category: "blue-dream",
    description: "A timeless celebration of tradition and grandeur, where heritage and romance shine in perfect harmony."
  },
  {
    id: "butterfly",
    title: "Butterfly",
    thumbnailImage: "https://res.cloudinary.com/dx5y2bzdq/image/upload/f_auto,q_auto,w_800/v1741781013/Butterfly_makrem_four_sesonsi0_zj8v3s.jpg",
    type: "wedding",
    category: "butterfly",
    description: "Bold tropical elegance merges with refined sophistication in our captivating jungle-inspired designs."
  },
  {
    id: "ihg-kuwait",
    title: "IHG Kuwait",
    thumbnailImage: "https://res.cloudinary.com/dx5y2bzdq/image/upload/f_auto,q_auto,w_800/v1740766101/7X7A4723_jvdsgm.jpg",
    video: "https://res.cloudinary.com/dx5y2bzdq/video/upload/v1740839983/KD_2_1_oion50.mp4",
    type: "corporate",
    category: "kuwait",
    description: "Innovative floral designs and advanced event styling, crafted to transform corporate gatherings at IHG Kuwait into sophisticated, visually stunning experiences."
  }
];

// ==================== CUSTOM HOOKS ====================
const useServiceFilter = (services) => {
  const [activeType, setActiveType] = useState(SERVICE_TYPES.WEDDING);
  const [searchQuery, setSearchQuery] = useState('');

  const filteredServices = useMemo(() => {
    return services.filter(service => {
      const matchesType = activeType === SERVICE_TYPES.ALL || service.type === activeType;
      const matchesSearch = searchQuery === '' ||
        service.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
        service.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
        service.category.toLowerCase().includes(searchQuery.toLowerCase());

      return matchesType && matchesSearch;
    });
  }, [services, activeType, searchQuery]);

  const serviceStats = useMemo(() => ({
    total: services.length,
    wedding: services.filter(s => s.type === SERVICE_TYPES.WEDDING).length,
    corporate: services.filter(s => s.type === SERVICE_TYPES.CORPORATE).length,
    filtered: filteredServices.length
  }), [services, filteredServices]);

  const handleTypeChange = useCallback((type) => {
    setActiveType(type);
    setSearchQuery('');
  }, []);

  const handleSearchChange = useCallback((query) => {
    setSearchQuery(query);
  }, []);

  return {
    activeType,
    searchQuery,
    filteredServices,
    serviceStats,
    handleTypeChange,
    handleSearchChange
  };
};

// Intersection Observer Hook for scroll animations
const useIntersectionObserver = (options = {}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [hasAnimated, setHasAnimated] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && !hasAnimated) {
        setIsVisible(true);
        setHasAnimated(true);
      }
    }, { threshold: 0.1, ...options });

    const currentRef = ref.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [hasAnimated, options]);

  return [ref, isVisible];
};

// Mouse parallax hook
const useMouseParallax = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      const x = (e.clientX / window.innerWidth - 0.5) * 20;
      const y = (e.clientY / window.innerHeight - 0.5) * 20;
      setPosition({ x, y });
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  return position;
};

// ==================== STYLES ====================
const styles = {
  // Main section with animated gradient background
  section: {
    position: 'relative',
    padding: '80px 0 100px',
    background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a2e 50%, #0f0f23 100%)',
    overflow: 'hidden',
    minHeight: '100vh',
  },

  // Animated background orbs
  backgroundOrb: {
    position: 'absolute',
    borderRadius: '50%',
    filter: 'blur(80px)',
    opacity: 0.4,
    pointerEvents: 'none',
  },

  // Glassmorphism container
  glassCard: {
    background: 'rgba(255, 255, 255, 0.03)',
    backdropFilter: 'blur(20px)',
    WebkitBackdropFilter: 'blur(20px)',
    border: '1px solid rgba(255, 255, 255, 0.08)',
    borderRadius: '24px',
  },

  // Luxury gold accent
  goldAccent: {
    background: 'linear-gradient(135deg, #d4af37 0%, #f4e5b6 50%, #d4af37 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
  },

  // Shimmer effect
  shimmer: {
    background: 'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.1) 50%, transparent 100%)',
    backgroundSize: '200% 100%',
    animation: 'shimmer 2s infinite',
  },
};

// ==================== SUB-COMPONENTS ====================

// Animated Background Component
const AnimatedBackground = ({ mousePosition }) => (
  <>
    {/* Floating orbs with parallax */}
    <div
      style={{
        ...styles.backgroundOrb,
        width: '600px',
        height: '600px',
        background: 'radial-gradient(circle, rgba(212, 175, 55, 0.3) 0%, transparent 70%)',
        top: '-200px',
        right: '-100px',
        transform: `translate(${mousePosition.x * 0.5}px, ${mousePosition.y * 0.5}px)`,
        transition: 'transform 0.3s ease-out',
      }}
    />
    <div
      style={{
        ...styles.backgroundOrb,
        width: '500px',
        height: '500px',
        background: 'radial-gradient(circle, rgba(244, 63, 94, 0.2) 0%, transparent 70%)',
        bottom: '-150px',
        left: '-100px',
        transform: `translate(${mousePosition.x * -0.3}px, ${mousePosition.y * -0.3}px)`,
        transition: 'transform 0.3s ease-out',
      }}
    />
    <div
      style={{
        ...styles.backgroundOrb,
        width: '400px',
        height: '400px',
        background: 'radial-gradient(circle, rgba(139, 92, 246, 0.15) 0%, transparent 70%)',
        top: '50%',
        left: '50%',
        transform: `translate(-50%, -50%) translate(${mousePosition.x * 0.2}px, ${mousePosition.y * 0.2}px)`,
        transition: 'transform 0.3s ease-out',
      }}
    />

    {/* Animated grid pattern */}
    <div
      style={{
        position: 'absolute',
        inset: 0,
        backgroundImage: `
          linear-gradient(rgba(255,255,255,0.02) 1px, transparent 1px),
          linear-gradient(90deg, rgba(255,255,255,0.02) 1px, transparent 1px)
        `,
        backgroundSize: '50px 50px',
        opacity: 0.5,
      }}
    />

    {/* Floating particles */}
    <div style={{ position: 'absolute', inset: 0, overflow: 'hidden', pointerEvents: 'none' }}>
      {[...Array(20)].map((_, i) => (
        <div
          key={i}
          style={{
            position: 'absolute',
            width: Math.random() * 4 + 2 + 'px',
            height: Math.random() * 4 + 2 + 'px',
            background: i % 2 === 0 ? 'rgba(212, 175, 55, 0.6)' : 'rgba(255, 255, 255, 0.4)',
            borderRadius: '50%',
            left: Math.random() * 100 + '%',
            top: Math.random() * 100 + '%',
            animation: `float ${5 + Math.random() * 10}s ease-in-out infinite`,
            animationDelay: `${Math.random() * 5}s`,
          }}
        />
      ))}
    </div>
  </>
);

// Luxury Section Header with animations
const SectionHeader = ({ title, subtitle }) => {
  const [ref, isVisible] = useIntersectionObserver();

  return (
    <div
      ref={ref}
      className={`text-center mb-16 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}
    >
      {/* Decorative top element */}
      <div className="flex justify-center items-center gap-4 mb-6">
        <div className="w-16 h-px bg-gradient-to-r from-transparent via-amber-500 to-transparent" />
        <div className="relative">
          <span className="text-amber-400 text-2xl">✦</span>
          <div className="absolute inset-0 animate-ping text-amber-400 text-2xl opacity-30">✦</div>
        </div>
        <div className="w-16 h-px bg-gradient-to-r from-transparent via-amber-500 to-transparent" />
      </div>

      {/* Main title with gradient */}
      <h2
        className="text-5xl md:text-6xl lg:text-7xl font-serif italic tracking-tight mb-6"
        style={styles.goldAccent}
      >
        {title}
      </h2>

      {/* Animated underline */}
      <div className="flex justify-center mb-6">
        <div className="relative">
          <div
            className={`h-1 bg-gradient-to-r from-amber-600 via-amber-400 to-amber-600 rounded-full transition-all duration-1000 delay-300 ${isVisible ? 'w-48' : 'w-0'
              }`}
          />
          <div
            className="absolute inset-0 h-1 bg-gradient-to-r from-amber-600 via-amber-400 to-amber-600 rounded-full blur-sm"
            style={{ opacity: isVisible ? 0.6 : 0 }}
          />
        </div>
      </div>

      {/* Subtitle */}
      {subtitle && (
        <p className="text-gray-400 text-lg md:text-xl max-w-3xl mx-auto leading-relaxed px-4 font-light tracking-wide">
          {subtitle}
        </p>
      )}
    </div>
  );
};

// Premium Filter Button Component
const FilterButton = ({ type, label, icon, gradient, isActive, onClick, count }) => (
  <button
    onClick={() => onClick(type)}
    className={`
      relative group flex-1 px-6 py-5 rounded-2xl font-serif text-lg tracking-wide
      transition-all duration-500 ease-out overflow-hidden
      ${isActive
        ? 'text-white shadow-2xl scale-105'
        : 'text-gray-400 hover:text-white'
      }
    `}
    style={{
      background: isActive
        ? `linear-gradient(135deg, var(--tw-gradient-stops))`
        : 'rgba(255, 255, 255, 0.03)',
      border: isActive
        ? 'none'
        : '1px solid rgba(255, 255, 255, 0.08)',
    }}
    aria-pressed={isActive}
  >
    {/* Active state gradient background */}
    {isActive && (
      <div
        className={`absolute inset-0 bg-gradient-to-r ${gradient} opacity-100`}
        style={{ zIndex: -1 }}
      />
    )}

    {/* Hover glow effect */}
    <div
      className={`
        absolute inset-0 bg-gradient-to-r ${gradient} opacity-0 
        group-hover:opacity-20 transition-opacity duration-500 blur-xl
      `}
    />

    {/* Shimmer effect on hover */}
    <div
      className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
      style={{
        background: 'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.1) 50%, transparent 100%)',
        transform: 'translateX(-100%)',
        animation: 'shimmer 2s infinite',
      }}
    />

    {/* Content */}
    <div className="relative flex items-center justify-center gap-3">
      <span className="text-2xl transform group-hover:scale-110 transition-transform duration-300">
        {icon}
      </span>
      <span className="hidden sm:inline">{label}</span>
      <span
        className={`
          ml-2 px-2.5 py-0.5 text-sm rounded-full transition-all duration-300
          ${isActive
            ? 'bg-white/20 text-white'
            : 'bg-white/5 text-gray-500 group-hover:bg-white/10'
          }
        `}
      >
        {count}
      </span>
    </div>

    {/* Active indicator dot */}
    {isActive && (
      <div className="absolute -bottom-1 left-1/2 transform -translate-x-1/2">
        <div className="w-2 h-2 rounded-full bg-white shadow-lg shadow-white/50" />
      </div>
    )}
  </button>
);

// Service Type Filter with glassmorphism
const ServiceTypeFilter = ({ activeType, onTypeChange, stats }) => {
  const [ref, isVisible] = useIntersectionObserver();

  return (
    <div
      ref={ref}
      className={`flex justify-center mt-12 mb-12 px-4 transition-all duration-700 delay-200 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
    >
      <div
        className="p-2 max-w-3xl w-full"
        style={{
          ...styles.glassCard,
          boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(212, 175, 55, 0.1)',
        }}
      >
        <div className="flex flex-col sm:flex-row gap-3 w-full">
          {FILTER_BUTTONS.map(({ type, label, icon, gradient }) => (
            <FilterButton
              key={type}
              type={type}
              label={label}
              icon={icon}
              gradient={gradient}
              isActive={activeType === type}
              onClick={onTypeChange}
              count={type === SERVICE_TYPES.WEDDING ? stats.wedding : stats.corporate}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

// Premium Search Bar with animations
const SearchBar = ({ value, onChange, placeholder }) => {
  const [isFocused, setIsFocused] = useState(false);
  const [ref, isVisible] = useIntersectionObserver();

  return (
    <div
      ref={ref}
      className={`max-w-2xl mx-auto mb-16 px-4 transition-all duration-700 delay-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
        }`}
    >
      <div
        className={`
          relative group transition-all duration-500
          ${isFocused ? 'scale-105' : 'scale-100'}
        `}
      >
        {/* Glow effect */}
        <div
          className={`
            absolute -inset-1 rounded-2xl bg-gradient-to-r from-amber-500 via-rose-500 to-violet-500
            opacity-0 blur-lg transition-opacity duration-500
            ${isFocused ? 'opacity-40' : 'group-hover:opacity-20'}
          `}
        />

        {/* Search input container */}
        <div
          className="relative"
          style={{
            ...styles.glassCard,
            padding: 0,
          }}
        >
          {/* Search icon */}
          <div className="absolute left-5 top-1/2 transform -translate-y-1/2 pointer-events-none">
            <svg
              className={`w-5 h-5 transition-colors duration-300 ${isFocused ? 'text-amber-400' : 'text-gray-500'
                }`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
          </div>

          <input
            type="text"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
            placeholder={placeholder}
            className="
              w-full pl-14 pr-6 py-5 rounded-2xl
              bg-transparent text-white placeholder-gray-500
              border-none outline-none
              text-lg font-light tracking-wide
            "
            aria-label="Search services"
          />

          {/* Clear button */}
          {value && (
            <button
              onClick={() => onChange('')}
              className="absolute right-5 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-amber-400 transition-colors duration-300"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

// Premium Video Indicator with animations
const VideoIndicator = () => (
  <div className="flex items-center gap-2 opacity-0 group-hover:opacity-100 transition-all duration-500 transform group-hover:translate-y-0 translate-y-2">
    <div className="relative">
      {/* Animated pulse ring */}
      <div className="absolute inset-0 rounded-full bg-amber-400 animate-ping opacity-25" />
      <div className="relative flex items-center justify-center w-8 h-8 rounded-full bg-gradient-to-r from-amber-500 to-amber-600 shadow-lg shadow-amber-500/30">
        <svg className="w-4 h-4 text-white ml-0.5" fill="currentColor" viewBox="0 0 24 24">
          <path d="M8 5v14l11-7z" />
        </svg>
      </div>
    </div>
    <span className="text-sm text-amber-400 font-medium tracking-wide">Watch Film</span>
  </div>
);

// Premium Service Card with advanced animations
const ServiceCard = ({ service, index }) => {
  const [ref, isVisible] = useIntersectionObserver();
  const [isHovered, setIsHovered] = useState(false);
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
  const cardRef = useRef(null);

  const handleMouseMove = (e) => {
    if (!cardRef.current) return;
    const rect = cardRef.current.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width - 0.5;
    const y = (e.clientY - rect.top) / rect.height - 0.5;
    setMousePos({ x, y });
  };

  return (
    <div
      ref={ref}
      className={`transition-all duration-700 ${isVisible
          ? 'opacity-100 translate-y-0'
          : 'opacity-0 translate-y-16'
        }`}
      style={{ transitionDelay: `${index * 100}ms` }}
    >
      <Link
        to={`/service/${service.id}`}
        ref={cardRef}
        className="block relative group"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => { setIsHovered(false); setMousePos({ x: 0, y: 0 }); }}
        onMouseMove={handleMouseMove}
        aria-label={`View ${service.title} service details`}
        style={{
          transform: isHovered
            ? `perspective(1000px) rotateY(${mousePos.x * 5}deg) rotateX(${-mousePos.y * 5}deg) scale(1.02)`
            : 'perspective(1000px) rotateY(0) rotateX(0) scale(1)',
          transition: 'transform 0.3s ease-out',
        }}
      >
        {/* Card glow effect */}
        <div
          className={`
            absolute -inset-1 rounded-3xl bg-gradient-to-r from-amber-500 via-rose-500 to-violet-500
            opacity-0 blur-lg transition-opacity duration-500
            ${isHovered ? 'opacity-50' : ''}
          `}
        />

        {/* Main card container */}
        <div
          className="relative rounded-3xl overflow-hidden"
          style={{
            ...styles.glassCard,
            border: isHovered
              ? '1px solid rgba(212, 175, 55, 0.3)'
              : '1px solid rgba(255, 255, 255, 0.08)',
          }}
        >
          {/* Image container */}
          <div className="relative h-[280px] sm:h-[320px] md:h-[380px] overflow-hidden">
            {/* Main image */}
            <img
              src={service.thumbnailImage}
              alt={service.title}
              className={`
                w-full h-full object-cover transition-all duration-700
                ${isHovered ? 'scale-110 blur-sm' : 'scale-100'}
              `}
              loading="lazy"
            />

            {/* Gradient overlay */}
            <div
              className={`
                absolute inset-0 transition-all duration-500
                ${isHovered
                  ? 'bg-gradient-to-t from-black via-black/70 to-black/30'
                  : 'bg-gradient-to-t from-black/90 via-black/40 to-transparent'
                }
              `}
            />

            {/* Animated border effect */}
            <div
              className={`
                absolute inset-0 opacity-0 transition-opacity duration-500
                ${isHovered ? 'opacity-100' : ''}
              `}
              style={{
                background: 'linear-gradient(135deg, rgba(212, 175, 55, 0.2) 0%, transparent 50%, rgba(212, 175, 55, 0.2) 100%)',
              }}
            />

            {/* Category badge */}
            <div
              className={`
                absolute top-5 right-5 transition-all duration-500
                ${isHovered ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'}
              `}
            >
              <div
                className="px-4 py-2 rounded-full text-xs font-medium capitalize tracking-wider"
                style={{
                  ...styles.glassCard,
                  background: 'rgba(212, 175, 55, 0.2)',
                  border: '1px solid rgba(212, 175, 55, 0.3)',
                  backdropFilter: 'blur(10px)',
                }}
              >
                <span className="text-amber-400">{service.category.replace(/-/g, ' ')}</span>
              </div>
            </div>

            {/* Type indicator */}
            <div className="absolute top-5 left-5">
              <div
                className={`
                  w-10 h-10 rounded-full flex items-center justify-center text-lg
                  transition-all duration-500 transform
                  ${isHovered ? 'scale-110 rotate-12' : 'scale-100'}
                `}
                style={{
                  ...styles.glassCard,
                  background: service.type === 'wedding'
                    ? 'rgba(244, 63, 94, 0.2)'
                    : 'rgba(251, 191, 36, 0.2)',
                  border: `1px solid ${service.type === 'wedding' ? 'rgba(244, 63, 94, 0.3)' : 'rgba(251, 191, 36, 0.3)'}`,
                }}
              >
                {service.type === 'wedding' ? '💒' : '🏢'}
              </div>
            </div>
          </div>

          {/* Content overlay */}
          <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
            {/* Title */}
            <h3
              className={`
                font-serif italic text-2xl md:text-3xl tracking-wide mb-3
                transition-all duration-500
                ${isHovered ? 'text-amber-400' : 'text-white'}
              `}
            >
              {service.title}
            </h3>

            {/* Animated underline */}
            <div className="relative h-0.5 mb-4">
              <div
                className={`
                  absolute left-0 h-full bg-gradient-to-r from-amber-500 to-rose-500 rounded-full
                  transition-all duration-500
                  ${isHovered ? 'w-full' : 'w-12'}
                `}
              />
              <div
                className="absolute left-0 h-full bg-gradient-to-r from-amber-500 to-rose-500 rounded-full blur-sm"
                style={{ width: isHovered ? '100%' : '48px', transition: 'width 0.5s' }}
              />
            </div>

            {/* Description */}
            <p
              className={`
                text-gray-400 text-sm md:text-base leading-relaxed
                transition-all duration-500 line-clamp-2
                ${isHovered ? 'opacity-100 translate-y-0' : 'opacity-70 translate-y-2'}
              `}
            >
              {service.description}
            </p>

            {/* Video indicator */}
            <div className="mt-4">
              {service.video && <VideoIndicator />}
            </div>

            {/* View details CTA */}
            <div
              className={`
                mt-4 flex items-center gap-2 text-amber-400 text-sm font-medium tracking-wide
                transition-all duration-500
                ${isHovered ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-4'}
              `}
            >
              <span>Explore Details</span>
              <svg
                className="w-4 h-4 transform group-hover:translate-x-1 transition-transform"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
              </svg>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
};

// Premium Service Grid with masonry-style layout
const ServiceGrid = ({ services }) => {
  if (services.length === 0) {
    return (
      <div className="text-center py-24">
        <div
          className="inline-flex items-center justify-center w-24 h-24 rounded-full mb-6"
          style={styles.glassCard}
        >
          <svg className="w-12 h-12 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <p className="text-gray-400 text-xl font-serif italic mb-2">No services found</p>
        <p className="text-gray-600 text-sm">Try adjusting your search or filter criteria</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 px-4">
      {services.map((service, index) => (
        <ServiceCard key={service.id} service={service} index={index} />
      ))}
    </div>
  );
};

// Luxury Results Counter
const ResultsInfo = ({ filtered, total, activeType }) => {
  const [ref, isVisible] = useIntersectionObserver();

  return (
    <div
      ref={ref}
      className={`text-center mt-16 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
        }`}
    >
      <div
        className="inline-flex items-center gap-4 px-8 py-4 rounded-full"
        style={{
          ...styles.glassCard,
          boxShadow: '0 4px 24px rgba(0, 0, 0, 0.3)',
        }}
      >
        <div className="flex items-center gap-2">
          <span className="text-2xl font-serif italic text-amber-400">{filtered}</span>
          <span className="text-gray-500">/</span>
          <span className="text-gray-500">{total}</span>
        </div>
        <div className="w-px h-6 bg-gray-700" />
        <span className="text-gray-400 text-sm tracking-wide">
          {activeType === SERVICE_TYPES.WEDDING ? 'Wedding' : 'Corporate'} Experiences
        </span>
      </div>
    </div>
  );
};

// ==================== MAIN COMPONENT ====================
const Services = () => {
  const { t } = useTranslation();
  const mousePosition = useMouseParallax();

  const {
    activeType,
    searchQuery,
    filteredServices,
    serviceStats,
    handleTypeChange,
    handleSearchChange
  } = useServiceFilter(SERVICES_DATA);

  return (
    <section
      id="services"
      aria-labelledby="services-heading"
      style={styles.section}
    >
      {/* Animated background */}
      <AnimatedBackground mousePosition={mousePosition} />

      {/* Content container */}
      <div className="relative z-10 max-w-7xl mx-auto">
        <SectionHeader
          title={t('Our Prestigious Services')}
          subtitle="Crafting extraordinary moments with unparalleled elegance, artistry, and meticulous attention to every detail"
        />

        <ServiceTypeFilter
          activeType={activeType}
          onTypeChange={handleTypeChange}
          stats={serviceStats}
        />

        <SearchBar
          value={searchQuery}
          onChange={handleSearchChange}
          placeholder={t('Search for your dream experience...')}
        />

        <ServiceGrid services={filteredServices} />

        <ResultsInfo
          filtered={filteredServices.length}
          total={serviceStats.total}
          activeType={activeType}
        />
      </div>

      {/* CSS Keyframes */}
      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          33% { transform: translateY(-10px) rotate(5deg); }
          66% { transform: translateY(5px) rotate(-5deg); }
        }
        
        @keyframes shimmer {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(100%); }
        }
        
        @keyframes pulse-glow {
          0%, 100% { opacity: 0.4; }
          50% { opacity: 0.8; }
        }
      `}</style>
    </section>
  );
};

export default Services;